@if (coExhibitors && coExhibitors.length > 0) {
<section class="exhibitor-slider-container" #connected>
  <div class="mdc-layout-grid no-offset-x">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 class="mat-headline-2" i18n="@@featureExhibitorDetails-pageTabExhibitor-coExhibitors">Mitaussteller</h2>
        <hr />
        <bau365-exhibitor-card-list
          [exhibitors]="coExhibitors"
          [parent]="exhibitor"
          [size]="size"
          [cardSliderConfig]="cardSliderConfig"
          context="exhibitor-details"
          [imageZoomed]="imageZoomed"
          [moreRouterLink]="['/fairs', exhibitor?.fair_id, 'search']"
          [moreQueryParams]="{
            searchTypes: 'EXHIBITOR',
            filter: stringifyFilter({ exhibitor: [exhibitor?.id ?? ''] })
          }"></bau365-exhibitor-card-list>
      </div>
    </div>
  </div>
</section>
} @if (parent) {
<section class="exhibitor-slider-container" #connected>
  <div class="mdc-layout-grid no-offset-x">
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <h2 i18n="@@featureExhibitorDetails-pageTabExhibitor-mainExhibitor">Hauptaussteller</h2>
        <hr />
        <div class="exhibitor__main-reference">
          <bau365-exhibitor-card
            [item]="parent"
            [fairId]="parent.fair_id"
            [size]="size"
            [pageContext]="'exhibitor-details'">
          </bau365-exhibitor-card>
        </div>
      </div>
    </div>
  </div>
</section>
}
